import { useMemo } from 'react';
import { formatDateTimeVector } from '../../utils/formatDateTimeVector';
export var useDatePickerFormattedValue = function useDatePickerFormattedValue(_ref, _ref2) {
  var internalValue = _ref.internalValue;
  var enableTimePicker = _ref2.enableTimePicker,
    formatDateTime = _ref2.formatDateTime;
  return useMemo(function () {
    if (internalValue.isInfinite()) {
      return '';
    }
    var dateStart = internalValue.dateStart;
    if (formatDateTime && dateStart) {
      return formatDateTime(dateStart.convertToLocalDate());
    }
    return formatDateTimeVector(dateStart, enableTimePicker);
  }, [internalValue, enableTimePicker, formatDateTime]);
};